import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import SignInForm from '@/screens/auth/SignInForm'

/**
 * `redirect` is where requireAuth (lib/auth/guards.ts) was sending the visitor
 * before it found no session — an app-relative href such as
 * `/portfolio?tab=holdings`.
 *
 * Only a path starting with a single `/` is accepted. `https://evil.example`
 * and the protocol-relative `//evil.example` are other people's origins, and a
 * login form that forwards to one on request is an open redirect — the classic
 * phishing hand-off. Anything else falls back to undefined, so a mangled URL
 * lands on the sign-in form rather than erroring the route out.
 */
const searchSchema = z.object({
  redirect: z
    .string()
    .refine((href) => href.startsWith('/') && !href.startsWith('//'))
    .optional()
    .catch(undefined),
})

export const Route = createFileRoute('/_auth/signin')({
  validateSearch: searchSchema,
  component: SignInRoute,
})

/** Thin: the form lives in its own module so tests can mount it without the
 *  generated route tree, which is not committed. */
function SignInRoute() {
  const { redirect } = Route.useSearch()
  return <SignInForm redirect={redirect} />
}
